import { each, pick, toArray } from 'lodash'

export const personBuildFullname = (
	v: Api.User | Api.Person | Api.Team | string,
	options?: { isTeam?: boolean; salutation?: boolean; title?: boolean }
): string | undefined => {
	const defaultOptions = { salutation: true, title: true, isTeam: false }
	const fullConfig = { ...defaultOptions, ...options }
	const properties = fullConfig.isTeam
		? ['first_name', 'last_name']
		: ['firstname', 'lastname']

	if (fullConfig.title && !fullConfig.isTeam) properties.unshift('title')
	if (fullConfig.salutation) properties.unshift('salutation')

	if (!v) {
		return undefined
	}
	if (typeof v === 'object') {
		if (Object.prototype.hasOwnProperty.call(v, 'team') && options?.isTeam) {
			v = v.team
		}
		if (
			Object.prototype.hasOwnProperty.call(v, 'persons') &&
			!options?.isTeam
		) {
			v = Array.isArray(v.persons) && v.persons.length > 0 ? v.persons[0] : {}
		}
		if (Object.prototype.hasOwnProperty.call(v, 'person') && !options?.isTeam) {
			v = v.person
		}
		each(properties, (property) => {
			if (!Object.prototype.hasOwnProperty.call(v, property)) {
				return false
			}
		})
		return toArray(pick(v, properties)).filter(Boolean).join(' ')
	}

	return v
}
